import { DateTime } from "luxon"
import { useQuery } from "@tanstack/react-query"
import api2 from "~/api2"

interface UseReportsSitesProps {
  campId: string
  startDate: DateTime
  endDate?: DateTime
  page: number
}

export function useReportsSites(
  { campId, startDate, endDate, page }: UseReportsSitesProps,
  options?: { enabled?: boolean },
) {
  const finalEndDate = endDate || startDate.endOf("day")

  return useQuery({
    queryKey: ["reports_sites", campId, startDate?.toISODate(), finalEndDate?.toISODate(), page],
    queryFn: () => api2.Reports.sites(campId, startDate, finalEndDate, page),
    retry: 1,
    gcTime: 500,
    enabled: Boolean(startDate?.isValid && finalEndDate?.isValid) && (options?.enabled ?? true),
  })
}
